import React from "react";
import { graphColor } from "./BreachConstants";

const BreachGraph = ({ active = 0 }) => {
    return (
        <div>
            <div className="breach-risk-graph-title-container">
                <span className="breach-graph-title low-risk-color">Low Risk (1-3)</span>
                <span className="breach-graph-title moderate-risk-color">Moderate Risk (4-6)</span>
                <span className="breach-graph-title high-risk-color">High Risk (7-10)</span>
            </div>

            <div style={{ height: "5rem" }}>
                <div className="row breach-graph-bg" style={{ height: "3rem" }}>
                    {new Array(10).fill(1).map((v, i) => {
                        return (
                            <div
                                key={`${i} - ${graphColor[i + 1]}`}
                                style={{
                                    borderLeft: i + 1 !== 10 ? "1px solid #d8dde6" : "none",
                                    borderRight: i + 1 === 10 ? "1px solid #d8dde6" : "none",
                                    position: "relative",
                                    width: i + 1 !== 10 ? "10.8%" : "2.6%",
                                    height: "100%",
                                }}
                            >
                                {active === i + 1 && active !== 10 ? <div className={`active-risk-point ${graphColor[active]["dotColor"]}`}></div> : null}

                                {active === 10 && i + 1 === 10 ? <div className={`active-risk-point last-active ${graphColor[active]["dotColor"]}`}></div> : null}
                                <span style={{ position: "absolute", left: "-10%", bottom: "-43%", color: "#617798" }}>{i + 1}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default BreachGraph;
